import { FieldSetting, FieldsType } from '../../data/models/Transactions'
import { isSmallDevice } from '../../util/util'

const transactionColumnParser = (content: any): FieldsType[] => {
  const { columns } = content.data
  const columnsRequired = columns
  return (
    columnsRequired?.map((data: any) => {
      return FieldSetting.create({
        id: `${data?.businessName}`,
        isChecked: data?.businessName === 'customerName' && isSmallDevice() ? true : data?.required ?? false,
        title: data?.name ?? 'NA',
        isDisable: data?.required ?? false,
      })
    }) ?? []
  )
}

export { transactionColumnParser }
